import styled from '@emotion/styled';
import { Modal, Stack } from '@ui-components/neo.tax';

export const QuestionSectionWrapper = styled(Stack)({
  width: '100%',
  maxWidth: '80rem',
});

export const SectionHeader = styled(Stack)({
  flex: '0 0 390px',
});

export const SectionContent = styled(Stack)({
  padding: '1.5rem',
  gap: '3.5rem',
});

export const QuestionSectionModal = styled(Modal)({
  maxWidth: '540px',
});
